import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Form } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import moment from "moment";
import Select from "react-select";
import { customStyles } from "../../selectStyles";
import { findSelectOption, seedSelectOptions } from "../../utility/selectFieldHelpers";
import Flatpickr from "react-flatpickr";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import { useTranslation } from "react-i18next";

const UpdateCCV = ({ showUpdateCCV, handleCloseCCV, userCcv, getUserCcv }) => {
  // console.log(userCcv?.resumeInfo?.fullName);
  const { t } = useTranslation();

  const sessionId = localStorage.getItem("sessionId");
  const [fullName, setFullName] = useState(userCcv?.resumeInfo?.fullName);
  const [email, setEmail] = useState(userCcv?.resumeInfo?.email);
  const [dob, setDob] = useState(userCcv?.resumeInfo?.dob);
  const [phoneNo, setPhoneNo] = useState(userCcv?.resumeInfo?.phoneNumber);
  const language = localStorage.getItem("Lang");
  //   const [websiteLink, setWebsiteLink] = useState(
  //     userCcv?.resumeInfo?.webSiteLink
  //   );
  const [websitecontent, setWebsitecontent] = useState("");
  const [error, setError] = useState("");
  const [errorp, setErrorP] = useState("");
  const validateWebsite = (value) => {
    // Regex to detect invalid prefixes and ensure a valid domain extension
    const invalidPrefixes = /^(http:|https:|http:\/\/|https:\/\/|www\.)/i;
    const validDomainExtension = /\.[a-z]{2,}$/i; // Matches ".com", ".org", ".net", etc.

    console.log("Input value:", value);
    console.log("Invalid prefix test result:", invalidPrefixes.test(value));
    console.log("Valid domain extension test result:", validDomainExtension.test(value));

    if (invalidPrefixes.test(value)) {
      setError("Website URL should not start with 'http', 'https', or 'www'.");
    } else if (!validDomainExtension.test(value)) {
      setError("Website URL must include a valid domain extension (e.g., '.com', '.org').");
    } else {
      setError(""); // Clear the error if the input is valid
    }

    setWebsitecontent(value); // Update the state with the user input
  };
  const [summary, setSummary] = useState(userCcv?.resumeInfo?.summary);
  const [title, setTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  // Master/GetCountriesDDL?search=India
  const [countryData, setCountryData] = useState([]);
  const [countryId, setCountryId] = useState(null);
  const [countrySearch, setCountrySearch] = useState(null);


  const getCountry = () => {
    axios
      .get(`Master/GetCountryDDL?search=${countrySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        console.log("countrycode00000000", res);

        const data = res.map((item) => ({
          value: item.countyId,
          label: item.countryName,
          code: item.phoneCode,
        }));
        setCountryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (countrySearch) {
      getCountry();
    }
  }, [countrySearch]);


  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);

  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&CountryID=${countryId || ""}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);


  const [phoneCodeV, setphoneCodeV] = useState(null);

  const phoneCodeValid = () => {
    axios
      .get(`General/GetPhoneValidationByCountryId?DeviceType=Web&CountryID=${countryId || ""}&langKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        console.log("phonecodev", response);
        setphoneCodeV(Number(res));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (countryId) {
      phoneCodeValid();
    }
  }, [countryId]);

  // const handlePhoneChange = (e) => {
  //   // Remove non-numeric characters
  //   const value = e.target.value.replace(/\D/g, "");
  //   setPhoneNo(value);

  //   // if (phoneCodeV?.minLength && phoneCodeV?.maxLength) {
  //   //   if (value.length < phoneCodeV.minLength || value.length > phoneCodeV.maxLength) {
  //   //     setError(`Phone number must be between ${phoneCodeV.minLength} and ${phoneCodeV.maxLength} digits.`);
  //   //   } else {
  //   //     setError("");
  //   //   }
  //   // }
  //    if (phoneCodeV ) {
  //     if (value.length < phoneCodeV  ) {
  //       setErrorP(`Phone number must be between ${phoneCodeV}digits.`);
  //     } else {
  //       setErrorP("");
  //     }
  //   }
  // };

  // state


  // when phoneLength changes (or loads), re-clamp the current value
  // useEffect(() => {
  //   if (phoneCodeV?.phoneLength) {
  //     setPhoneNo((prev) => prev.replace(/\D/g, "").slice(0, Number(phoneCodeV.phoneLength)));
  //   }
  // }, [phoneCodeV?.phoneLength]);

  const handlePhoneChange = (e) => {
    const maxLen = Number(phoneCodeV) || 15; // fallback
    const next = e.target.value.replace(/\D/g, "").slice(0, maxLen); // digits only + hard cap
    setPhoneNo(next);

    if (phoneCodeV) {
      setErrorP(
        next.length === Number(phoneCodeV)
          ? ""
          : `Phone number must be ${phoneCodeV} digits.`
      );
    }
  };

  const handlePhonePaste = (e) => {
    e.preventDefault();
    const maxLen = Number(phoneCodeV) || 15;
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    const next = pasted.replace(/\D/g, "").slice(0, maxLen);
    setPhoneNo(next);

    if (phoneCodeV) {
      setErrorP(
        next.length === Number(phoneCodeV)
          ? ""
          : `Phone number must be ${phoneCodeV} digits.`
      );
    }
  };





  const [phoneCode, setPhoneCode] = useState(userCcv?.resumeInfo?.phoneCode || "");
  const handleCountryChange = (selectedOption) => {
    setCountryId(selectedOption.value);
    setPhoneCode(selectedOption.code); // auto update phone code
    phoneCodeValid(selectedOption.value); // call phone validation API
    // console.log("selectedcode", selectedOption.phoneCode, selectedOption.value);

  };


  const handleSubmit = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      rsmId: userCcv?.resumeInfo?.resumeId,
      fullName: fullName || userCcv?.resumeInfo?.fullName,
      dob:
        dob === ""
          ? userCcv?.resumeInfo?.dob
          : moment(dob).format("YYYY-MM-DD"),
      title: title,
      userImage: "string",
      currentCityId: cityId,
      nationalityCountyId: countryId,
      countryCodeCountryId: countryId,
      email: email || userCcv?.resumeInfo?.email,
      phoneNumber: phoneNo || userCcv?.resumeInfo?.phoneNumber,
      webSiteLink: websitecontent || userCcv?.resumeInfo?.websitecontent,
      summary: summary || userCcv?.resumeInfo?.summary,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.put(`Resume/UpdateResume`, data).then((resData) => {
        // console.log('resData', resData);
        // toast.success(resData.data.message)
        setToastMessage(resData.data.message);
        setShowToast(true);
        getUserCcv();
        handleCloseCCV();
        setErrorP("");
      });
    } catch (error) {
      console.log(error);
      // toast.error(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  useEffect(() => {
    if (showUpdateCCV) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = '';
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showUpdateCCV]);

  useEffect(() => {
    setCountryId(userCcv?.resumeInfo?.nationalityCountryId);
    setCountrySearch(userCcv?.resumeInfo?.nationalityCountry);
    setPhoneCode(userCcv?.resumeInfo?.phoneCode);
    setCityId(userCcv?.resumeInfo?.currentCityId);
    setCitySearch(userCcv?.resumeInfo?.currentCity);
    setDob(userCcv?.resumeInfo?.dob);
    setWebsitecontent(userCcv?.resumeInfo?.webSiteLink);
    if (userCcv?.resumeInfo?.currentCityId && userCcv?.resumeInfo?.currentCity) {
      setCityData(seedSelectOptions(
        userCcv.resumeInfo.currentCityId,
        userCcv.resumeInfo.currentCity
      ));
    }
    if (userCcv?.resumeInfo?.nationalityCountryId && userCcv?.resumeInfo?.nationalityCountry) {
      setCountryData(seedSelectOptions(
        userCcv.resumeInfo.nationalityCountryId,
        userCcv.resumeInfo.nationalityCountry
      ));
    }
  }, [userCcv?.resumeInfo]);

  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };

  return (
    <>
      {showUpdateCCV && userCcv?.resumeInfo && (
        <div
          className="modal modal-lg fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6 className="mb-0">{t("User Profile.Basic Info")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={handleCloseCCV}
                />
              </div>
              <Form>
                <div className="row pe-4 ps-4 pt-1 settings CreateCompany">
                  <div className="col-md-6">
                    <label htmlFor="about">{t("User Profile.FullName")}</label>
                    <input
                      type="text"
                      defaultValue={fullName || userCcv?.resumeInfo?.fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <label htmlFor="about">{t("User Profile.Email")}</label>
                    <input
                      type="text"
                      defaultValue={email || userCcv?.resumeInfo?.email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.Title")}</label><span className="text-danger ms-2">*</span>
                    <input
                      type="text"
                      defaultValue={title || userCcv?.resumeInfo?.title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.DOB")}</label>
                    <Flatpickr
                      className="form-control"
                      value={dob}
                      onChange={(date) => setDob(date[0])}
                      id="dob"
                      options={{
                        maxDate: "today", // Disables future dates
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.Country")}</label>
                    <Select
                      onChange={handleCountryChange}
                      value={findSelectOption(countryData, countryId)}
                      // onChange={(selectedOption) =>
                      //   setCountryId(selectedOption.value)
                      // }
                      options={countryData}
                      placeholder={t("User Profile.Search and Select Country")}
                      onInputChange={(inputValue) => {
                        setCountrySearch(inputValue);
                      }}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.City")}</label>
                    <Select
                      // defaultValue={cityId}
                      value={findSelectOption(cityData, cityId)}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      placeholder={t("modals.Search and Select City")}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.Phone Number")}</label>
                    <div className="col-md-12 mt-1 web-input websiteInput">
                      <div className="input-group input-group-alt ">
                        <div className="input-group-prepend">
                          <span className="input-group-text">+{phoneCode}</span>
                        </div>
                        {/* <input
                          type="text"
                          className="form-control ps-2 pb-0"
                          id="pi3"
                          placeholder="phone number"           
                          defaultValue={phoneNo || userCcv?.resumeInfo?.phoneNumber}
                          // onChange={(e) => setPhoneNo(e.target.value)} 
                          onChange={handlePhoneChange}
                        /> */}
                        <input
                          type="tel"
                          inputMode="numeric"
                          pattern="\d*"
                          className="form-control ps-2 pb-0"
                          id="pi3"
                          placeholder={t("User Profile.Phone Number")}
                          value={phoneNo}
                          maxLength={Number(phoneCodeV?.phoneLength) || undefined}
                          defaultValue={phoneNo || userCcv?.resumeInfo?.phoneNumber}

                          onChange={handlePhoneChange}
                          onPaste={handlePhonePaste}
                        />

                      </div>
                      {errorp && <div style={{ color: "red", marginTop: "5px", fontSize: '12px' }}>{errorp}</div>}
                    </div>
                  </div>
                  <div className="col-md-6 mt-1">
                    <label htmlFor="about">{t("User Profile.Website Link")}</label>
                    <div className="col-md-12 mt-1 web-input websiteInput">
                      <div className="input-group input-group-alt ">
                        <div className="input-group-prepend">
                          <span className="input-group-text">http://</span>
                        </div>
                        <input
                          type="text"
                          className="form-control ps-2 pb-0"
                          id="pi3"
                          placeholder="example.com"
                          value={websitecontent || userCcv?.resumeInfo?.websitecontent}
                          onChange={(e) => validateWebsite(e.target.value)}
                        />
                      </div>
                      {error && <div style={{ color: "red", marginTop: "5px", fontSize: '12px' }}>{error}</div>}
                    </div>
                    {/* <input type='text'
                                            defaultValue={websiteLink || userCcv?.resumeInfo?.webSiteLink}
                                            onChange={e => setWebsiteLink(e.target.value)}
                                        /> */}
                  </div>

                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">{t("User Profile.Summary")}</label>
                    <textarea
                      id="about"
                      name="about"
                      rows="3"
                      cols="50"
                      defaultValue={summary || userCcv?.resumeInfo?.summary}
                      onChange={(e) => setSummary(e.target.value)}
                    ></textarea>
                  </div>

                  <div className={`mt-4 ${language === "ar" ? "text-start" : "text-end"}`}>
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={handleSubmit}
                    >
                      {t("Manage Job.Update")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default UpdateCCV;
